import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

import { DspEntityId } from './dsp-entity-id'
import { LiveAd } from './live-ad'

export const GetLiveAdRequest = z.object({
  liveAdId: DspEntityId,
})
export type GetLiveAdRequest = z.infer<typeof GetLiveAdRequest>

export const GetLiveAdResponse = z.object({
  liveAd: LiveAd.optional(),
})
export type GetLiveAdResponse = z.infer<typeof GetLiveAdResponse>

export const getLiveAdDeclaration = endpointDeclaration(GetLiveAdRequest, GetLiveAdResponse)
